import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2qbyxhh869: FaireBrandEntity = {
  token: "b_2qbyxhh869",
  type: "brand",
  name: "Prettygoods",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a5fc08e5ebcf12ce12943d1619af7e848fb1f1b8e864202c589b24e1a00ce68.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/360479b248132a54007a4100765fee1a540b6fd851edd93566def3f22b653422.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a5fc08e5ebcf12ce12943d1619af7e848fb1f1b8e864202c589b24e1a00ce68.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/360479b248132a54007a4100765fee1a540b6fd851edd93566def3f22b653422.jpeg",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    'Crystals, minerals, and specimens are our bread and butter. Staring at rocks for much too long is our passion. At Prettygoods we pride ourselves on building strong relationships with miners and their families around the world that help our little crystal business thrive. Everything is genuine, natural, and ethically sourced. Everything is saged, cleansed of negative energy, and shipped to you directly from our little abode in Dallas, Texas. Reach out to us anytime to say "Hey!" ',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.950Z",
    importedBy: "entity-db-cli",
  },
};
